import Http from '../api/http';

export default class OfficialWebsiteKnowledge extends Http {
  constructor() {
    super();
  }

  /***********官网知识库***************/
  /**
   * 状态下拉列表
   */
  officialWebsiteKnowledge_getStatusList() {
    return super.post('officialWebsiteKnowledge/getStatusList', ...arguments);
  }

  /**
   * 获取商务二维码
   */
  officialWebsiteKnowledge_getBusinessQRCode() {
    return super.post('officialWebsiteKnowledge/getBusinessQRCode', ...arguments);
  }

  /**
   * 更新商务二维码
   */
  officialWebsiteKnowledge_addOrUpdateBusinessQRCode() {
    return super.post('officialWebsiteKnowledge/addOrUpdateBusinessQRCode', ...arguments);
  }

  /**
   * 列表
   * @param {string} title -  标题
   * @param {integer} status -  状态
   * @param {string} tag -  标签名称
   * @param {integer} homepageFocusStatus -  是否首焦：0：否，1：是
   * @param {integer} clickNumSort -  点击量排序 0：正序，1：倒叙
   * @param {integer} userNumSort -  访客数:访问该文章独立IP数 排序 0：正序，1：倒叙
   */
  officialWebsiteKnowledge_getList() {
    return super.post('officialWebsiteKnowledge/getList', ...arguments);
  }
  /**
   * 设置首焦/取消首焦
   */
  officialWebsiteKnowledge_setHomepageFocusInfo() {
    return super.post('officialWebsiteKnowledge/setHomepageFocusInfo', ...arguments);
  }
  /**
   * 上线/下线
   */
  officialWebsiteKnowledge_onOffLine() {
    return super.post('officialWebsiteKnowledge/onOffLine', ...arguments);
  }
  /**
   * 删除
   */
  officialWebsiteKnowledge_delInfo() {
    return super.post('officialWebsiteKnowledge/delInfo', ...arguments);
  }
  /**
   * 新增官网知识库数据
   * @param {string} image -  封面
   * @param {integer} sort -  排序
   * @param {string} title -  标题
   * @param {string} summary -  摘要
   * @param {array} tagInfos -  标签list
   * @param {string} content -  内容
   * @param {integer} autoOnline -  是否自动上线 0-否 1-是
   * @param {integer} autoOnline -  是否自动下线 0-否 1-是
   * @param {string} autoOnlineTime -  自动上线时间 yyyy-MM-dd HH:mm
   * @param {string} autoOfflineTime -  自动下线时间 yyyy-MM-dd HH:mm
   * @param {string} type -  类型 0：保存，1：保存并发布
   */
  officialWebsiteKnowledge_addKnowledge() {
    return super.post('officialWebsiteKnowledge/addKnowledge', ...arguments);
  }

  /**
   * 知识库详情
   */
  officialWebsiteKnowledge_getDetail() {
    return super.post('officialWebsiteKnowledge/getDetail', ...arguments);
  }
  /**
   * 更新某条知识库数据
   */
  officialWebsiteKnowledge_updateKnowledge() {
    return super.post('officialWebsiteKnowledge/updateKnowledge', ...arguments);
  }
}
